import { createContext } from 'react';
export var I18nContext = createContext({
    translate: function (x) { return x; },
    changeLocale: function () { return Promise.resolve(); },
    getLocale: function () { return 'en'; },
});
I18nContext.displayName = 'I18nContext';
//# sourceMappingURL=I18nContext.js.map